import { useEffect } from 'react';

const SITE_URL = 'https://ixoraly.com';
const SITE_NAME = 'Ixoraly';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_pr-platform-4/artifacts/z6ztu1ue_Transparent%20background%20-%20Copy.png';

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLd(id, data) {
  let el = document.querySelector(`script[data-jsonld="${id}"]`);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-jsonld', id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

const SEO = ({ title, description, path, type = 'website', article = null }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Professional Press Release Distribution`;
  const canonicalUrl = `${SITE_URL}${path || ''}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('description', description);
    setCanonical(canonicalUrl);

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:type', type, true);
    setMeta('og:site_name', SITE_NAME, true);
    setMeta('og:image', DEFAULT_IMAGE, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    setMeta('twitter:image', DEFAULT_IMAGE);

    if (article) {
      setJsonLd('article', {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        headline: article.title,
        description: article.excerpt,
        datePublished: article.date,
        dateModified: article.updatedAt || article.date,
        author: { '@type': 'Organization', name: article.author || 'Ixoraly Media' },
        publisher: {
          '@type': 'Organization',
          name: 'Ixoraly',
          logo: { '@type': 'ImageObject', url: DEFAULT_IMAGE }
        },
        mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
        image: article.featuredImage || DEFAULT_IMAGE
      });
    }
  }, [fullTitle, description, canonicalUrl, type, article]);

  return null;
};

export default SEO;
